const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the category search component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('categorySearch', ['Categories', '$q', function (Categories, $q) {
  return {
    restrict: 'E',
    scope: {
      selections: '=?',
      onAdd: '&?',
      showDecendants: '@',
      type: '@'
    },
    template: require('../../../templates/directives/categories/category-search.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      var type = $scope.type || ['locations', 'departments', 'teams', 'org_levels', 'grades'];

      self.searchText = '';
      self.queries = [];
      self.options = [];

      // Attach legacy name to category in options
      self.legacyName = function(item) {
        var parentName;
        var papaName;

        item.text = item.name;
        item.lineage_ids = [item._id];

        if (item.parent && item.parent.name) {
          parentName = item.parent.name + ' -> ';
          item.text = parentName + item.text;
        }

        if (item.parent && item.parent.parent && item.parent.parent.name) {
          papaName = item.parent.parent.name + ' -> ';
          item.text = papaName + item.text;
        }
      };

      // Get category options based on input
      self.getOptions = function(input) {
        var deferred = $q.defer();

        input = input ? input.toLowerCase() : '';

        if (!input) {
          return deferred.resolve([]);
        }

        var query = {
          term: input,
          types: type.join(','),
          ignoreSelections: $scope.showDecendants ? true : false,
        };
        if ($scope.selections && $scope.selections.length) {
          query.selections = $scope.selections.join(',');
        }

        self.options.splice(0);

        Categories.search(query).$promise
        .then(function(data) {
          console.log('data: ', data)

          if (!$scope.group) {
            $scope.group = {};
            if ($scope.type === 'category') {
              $scope.group = [];
            }
          }

          var placeholders = {
            location: {name: 'Locations', text: 'Locations', _id: 'locations', placeholder: true},
            department: {name: 'Departments', text: 'Departments', _id: 'departments', placeholder: true},
            team: {name: 'Teams', text: 'Teams', _id: 'teams', placeholder: true},
            org_level: {name: 'Level', text: 'Level', _id: 'org_levels', placeholder: true},
            grade: {name: 'Grade', text: 'Grade', _id: 'grades', placeholder: true},
            category: {name: 'Category', text: 'Category', _id: 'categories', placeholder: true}
          };

          var matches = {
            location: [],
            department: [],
            team: [],
            org_level: [],
            grade: [],
            category: []
          };

          data.forEach(function(item) {
            var itemType = item.location ? 'location' : item.department ? 'department' : item.team ? 'team' : item.org_level ? 'org_level' : item.grade ? 'grade' : item.category ? 'category' : '';

            if (!itemType || !matches[itemType]) {
              return;
            }

            // Add legacy name
            self.legacyName(item);
            item.type = itemType;

            // Add item to matches type
            matches[itemType].push(item);
          });

          // Add requisite placeholder
          for (var key in matches) {
            if (matches[key].length) {
              self.options.push(placeholders[key]);
              self.options = self.options.concat(matches[key]);
            }
          }

          deferred.resolve(self.options);

        }).catch(function(error) {
          console.log('error in categoreis search: ', error);
        });

        return deferred.promise;

      };

      // Add selection to selections
      self.itemAdding = function(type, item) {
        if (!item || !type) {
          return false;
        }
        self.searchText = '';

        if ($scope.onAdd) {
          $scope.onAdd({item: item});
        }

        self.options.splice(0);

        return false;
      };


    }],
    controllerAs: 'categorySearch'
  };
}]);
